// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.learn-island {
    margin: 0 0 16px;
}
.learn-island__card {
    background: #fff;
    border: 1px solid #ECEEF1;
    border-radius: 14px;
    padding: 18px 16px 12px;
    box-shadow: 0 1px 2px rgba(16, 24, 40, 0.04), 0 6px 20px rgba(16, 24, 40, 0.05);
}
.learn-island__header {
    display: flex;
    flex-direction: column;
    gap: 4px;
    margin-bottom: 10px;
}
.learn-island__title-row {
    display: flex;
    align-items: flex-start;
    justify-content: space-between;
    gap: 12px;
}
.learn-island__title {
    font-size: 18px;
    font-weight: 700;
    line-height: 1.3;
    margin: 0;
    color: #1f1f1f;
    flex: 1;
}
.learn-island__user-info {
    font-size: 13px;
    color: #4b5563;
    margin: 0;
    font-weight: 600;
}
.learn-island__date {
    font-size: 12px;
    color: #6b7280;
    margin: 0;
}
.learn-island__divider {
    height: 1px;
    background: #e5e7eb;
    margin: 12px 0 4px;
}
.learn-island__score-label {
    display: flex;
    align-items: center;
    justify-content: center;
    position: relative;
    text-align: center;
    font-size: 14px;
    color: #1f1f1f;
    margin: 10px 0;
}
.learn-island__score {
    /* Wrapper around the reused QuizScoreCard, provides spacing only */
    margin-top: 4px;
}
/* The shared QuizScoreCard prints a blue "Score" title. On this green Quizzory page that blue is
   off brand and it just repeats the "Your Score" header above it, so hide it here only (scoped to
   the learn page, no effect on the SurveyHeart surfaces that reuse QuizScoreCard). */
.learn-island__score .score-card-title { display: none; }
.learn-island__score .pending-card-container {
    width: 100%;
    box-sizing: border-box;
    align-items: center;
}

.pending-card-container {
    width: 86%;
    display: flex;
    flex-direction: column;
    padding: 15px;
    background-color: #F5F5F5;
    border-radius: 5px;
}

.pending-card-container span {
    margin: 4px 0;
}
.learn-island__toggle {
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 8px;
    width: 100%;
    min-height: 44px;
    padding: 10px 12px;
    border: none;
    border-top: 1px solid #e5e7eb;
    background: transparent;
    color: #1f1f1f;
    font-family: inherit;
    font-size: 14px;
    font-weight: 600;
    cursor: pointer;
    margin-top: 8px;
}
.learn-island__toggle:hover { background: #f9fafb; }
/*.learn-island__toggle:focus { outline: 2px solid #2563eb; outline-offset: -2px; }*/

.learn-island__detail {
    margin-top: 12px;
    background: #fff;
    border: 1px solid #ECEEF1;
    border-radius: 14px;
    padding: 12px 0 0;
    box-shadow: 0 1px 2px rgba(16, 24, 40, 0.04), 0 6px 20px rgba(16, 24, 40, 0.05);
}
.learn-island__detail .individual-question-card-inner-wrapper {
    width: 100%;
    max-width: none;
    margin-bottom: 0;
    padding: 0;
    box-shadow: none;
}
.learn-island__detail .individual-response-question-card {
    width: 100%;
}

/* Share button */
.learn-share-btn {
    display: inline-flex;
    align-items: center;
    gap: 6px;
    padding: 8px 12px;
    min-height: 36px;
    background: #f3f4f6;
    color: #1f1f1f;
    border: 1px solid #e5e7eb;
    border-radius: 999px;
    font-family: inherit;
    font-size: 13px;
    font-weight: 600;
    cursor: pointer;
}
.learn-share-btn:hover { background: #e5e7eb; }
.learn-share-btn:focus { outline: 2px solid #1B5E20; outline-offset: 2px; }

@media (min-width: 768px) {
    .learn-island__card { padding: 22px 22px 14px; }
    .learn-island__title { font-size: 20px; }
}

@media (max-width: 480px) {
    .learn-share-btn { padding: 8px 10px; }
    .learn-share-btn span { display: none; }
    .pending-card-container {
        background-color: #fff;
        box-shadow: 0 4px 10px rgba(0, 0, 0, 0.25);
    }
}

@media print {
    .learn-share-btn {
        display: none;
    }
    .learn-island__toggle {
        display: none;
    }
}
`, "",{"version":3,"sources":["webpack://./src/learn/css/learn-island.css"],"names":[],"mappings":"AAAA;IACI,gBAAgB;AACpB;AACA;IACI,gBAAgB;IAChB,yBAAyB;IACzB,mBAAmB;IACnB,uBAAuB;IACvB,+EAA+E;AACnF;AACA;IACI,aAAa;IACb,sBAAsB;IACtB,QAAQ;IACR,mBAAmB;AACvB;AACA;IACI,aAAa;IACb,uBAAuB;IACvB,8BAA8B;IAC9B,SAAS;AACb;AACA;IACI,eAAe;IACf,gBAAgB;IAChB,gBAAgB;IAChB,SAAS;IACT,cAAc;IACd,OAAO;AACX;AACA;IACI,eAAe;IACf,cAAc;IACd,SAAS;IACT,gBAAgB;AACpB;AACA;IACI,eAAe;IACf,cAAc;IACd,SAAS;AACb;AACA;IACI,WAAW;IACX,mBAAmB;IACnB,kBAAkB;AACtB;AACA;IACI,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,kBAAkB;IAClB,kBAAkB;IAClB,eAAe;IACf,cAAc;IACd,cAAc;AAClB;AACA;IACI,mEAAmE;IACnE,eAAe;AACnB;AACA;;qFAEqF;AACrF,yCAAyC,aAAa,EAAE;AACxD;IACI,WAAW;IACX,sBAAsB;IACtB,mBAAmB;AACvB;;AAEA;IACI,UAAU;IACV,aAAa;IACb,sBAAsB;IACtB,aAAa;IACb,yBAAyB;IACzB,kBAAkB;AACtB;;AAEA;IACI,aAAa;AACjB;AACA;IACI,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,QAAQ;IACR,WAAW;IACX,gBAAgB;IAChB,kBAAkB;IAClB,YAAY;IACZ,6BAA6B;IAC7B,uBAAuB;IACvB,cAAc;IACd,oBAAoB;IACpB,eAAe;IACf,gBAAgB;IAChB,eAAe;IACf,eAAe;AACnB;AACA,8BAA8B,mBAAmB,EAAE;AACnD,oFAAoF;;AAEpF;IACI,gBAAgB;IAChB,gBAAgB;IAChB,yBAAyB;IACzB,mBAAmB;IACnB,iBAAiB;IACjB,+EAA+E;AACnF;AACA;IACI,WAAW;IACX,eAAe;IACf,gBAAgB;IAChB,UAAU;IACV,gBAAgB;AACpB;AACA;IACI,WAAW;AACf;;AAEA,iBAAiB;AACjB;IACI,oBAAoB;IACpB,mBAAmB;IACnB,QAAQ;IACR,iBAAiB;IACjB,gBAAgB;IAChB,mBAAmB;IACnB,cAAc;IACd,yBAAyB;IACzB,oBAAoB;IACpB,oBAAoB;IACpB,eAAe;IACf,gBAAgB;IAChB,eAAe;AACnB;AACA,yBAAyB,mBAAmB,EAAE;AAC9C,yBAAyB,0BAA0B,EAAE,mBAAmB,EAAE;;AAE1E;IACI,sBAAsB,uBAAuB,EAAE;IAC/C,uBAAuB,eAAe,EAAE;AAC5C;;AAEA;IACI,mBAAmB,iBAAiB,EAAE;IACtC,wBAAwB,aAAa,EAAE;IACvC;QACI,sBAAsB;QACtB,0CAA0C;IAC9C;AACJ;;AAEA;IACI;QACI,aAAa;IACjB;IACA;QACI,aAAa;IACjB;AACJ","sourcesContent":[".learn-island {\n    margin: 0 0 16px;\n}\n.learn-island__card {\n    background: #fff;\n    border: 1px solid #ECEEF1;\n    border-radius: 14px;\n    padding: 18px 16px 12px;\n    box-shadow: 0 1px 2px rgba(16, 24, 40, 0.04), 0 6px 20px rgba(16, 24, 40, 0.05);\n}\n.learn-island__header {\n    display: flex;\n    flex-direction: column;\n    gap: 4px;\n    margin-bottom: 10px;\n}\n.learn-island__title-row {\n    display: flex;\n    align-items: flex-start;\n    justify-content: space-between;\n    gap: 12px;\n}\n.learn-island__title {\n    font-size: 18px;\n    font-weight: 700;\n    line-height: 1.3;\n    margin: 0;\n    color: #1f1f1f;\n    flex: 1;\n}\n.learn-island__user-info {\n    font-size: 13px;\n    color: #4b5563;\n    margin: 0;\n    font-weight: 600;\n}\n.learn-island__date {\n    font-size: 12px;\n    color: #6b7280;\n    margin: 0;\n}\n.learn-island__divider {\n    height: 1px;\n    background: #e5e7eb;\n    margin: 12px 0 4px;\n}\n.learn-island__score-label {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    position: relative;\n    text-align: center;\n    font-size: 14px;\n    color: #1f1f1f;\n    margin: 10px 0;\n}\n.learn-island__score {\n    /* Wrapper around the reused QuizScoreCard, provides spacing only */\n    margin-top: 4px;\n}\n/* The shared QuizScoreCard prints a blue \"Score\" title. On this green Quizzory page that blue is\n   off brand and it just repeats the \"Your Score\" header above it, so hide it here only (scoped to\n   the learn page, no effect on the SurveyHeart surfaces that reuse QuizScoreCard). */\n.learn-island__score .score-card-title { display: none; }\n.learn-island__score .pending-card-container {\n    width: 100%;\n    box-sizing: border-box;\n    align-items: center;\n}\n\n.pending-card-container {\n    width: 86%;\n    display: flex;\n    flex-direction: column;\n    padding: 15px;\n    background-color: #F5F5F5;\n    border-radius: 5px;\n}\n\n.pending-card-container span {\n    margin: 4px 0;\n}\n.learn-island__toggle {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    gap: 8px;\n    width: 100%;\n    min-height: 44px;\n    padding: 10px 12px;\n    border: none;\n    border-top: 1px solid #e5e7eb;\n    background: transparent;\n    color: #1f1f1f;\n    font-family: inherit;\n    font-size: 14px;\n    font-weight: 600;\n    cursor: pointer;\n    margin-top: 8px;\n}\n.learn-island__toggle:hover { background: #f9fafb; }\n/*.learn-island__toggle:focus { outline: 2px solid #2563eb; outline-offset: -2px; }*/\n\n.learn-island__detail {\n    margin-top: 12px;\n    background: #fff;\n    border: 1px solid #ECEEF1;\n    border-radius: 14px;\n    padding: 12px 0 0;\n    box-shadow: 0 1px 2px rgba(16, 24, 40, 0.04), 0 6px 20px rgba(16, 24, 40, 0.05);\n}\n.learn-island__detail .individual-question-card-inner-wrapper {\n    width: 100%;\n    max-width: none;\n    margin-bottom: 0;\n    padding: 0;\n    box-shadow: none;\n}\n.learn-island__detail .individual-response-question-card {\n    width: 100%;\n}\n\n/* Share button */\n.learn-share-btn {\n    display: inline-flex;\n    align-items: center;\n    gap: 6px;\n    padding: 8px 12px;\n    min-height: 36px;\n    background: #f3f4f6;\n    color: #1f1f1f;\n    border: 1px solid #e5e7eb;\n    border-radius: 999px;\n    font-family: inherit;\n    font-size: 13px;\n    font-weight: 600;\n    cursor: pointer;\n}\n.learn-share-btn:hover { background: #e5e7eb; }\n.learn-share-btn:focus { outline: 2px solid #1B5E20; outline-offset: 2px; }\n\n@media (min-width: 768px) {\n    .learn-island__card { padding: 22px 22px 14px; }\n    .learn-island__title { font-size: 20px; }\n}\n\n@media (max-width: 480px) {\n    .learn-share-btn { padding: 8px 10px; }\n    .learn-share-btn span { display: none; }\n    .pending-card-container {\n        background-color: #fff;\n        box-shadow: 0 4px 10px rgba(0, 0, 0, 0.25);\n    }\n}\n\n@media print {\n    .learn-share-btn {\n        display: none;\n    }\n    .learn-island__toggle {\n        display: none;\n    }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
